import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { AuthContext } from '../../context/auth-context';
import MainHeader from './MainHeader';
import NavLinks from './NavLinks';
import SideDrawer from './SideDrawer';
import Backdrop from '../UIElements/Backdrop';
import Skeleton from '../Skeleton/skeleton';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { useStoreDetailsContext } from '../../context/store-details-context';
import { useThemeContext } from '../../context/theme-context';
import { useLanguageContext } from '../../context/language-context';
import useTranslation from '../../Hooks/translation-hook';
import getLocalizedValue from '../../util/get-localized-value';

import './MainNavigation.css';

const MainNavigation = () => {
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const auth = useContext(AuthContext);
  const { pathname } = useLocation();
  const { currentLanguage } = useTranslation();
  const { isStoreRoute } = useLanguageContext();
  const isLoginPage = pathname === '/login';

  const {
    storeDetails,
    isUpdatedStoreDetails,
    HideStoreDetailsSkeleton,
  } = useStoreDetailsContext();

  const {
    theme,
    isUpdatedTheme,
    HideThemeSkeleton,
  } = useThemeContext();

  const isAdminQrRoute = auth.role === 'admin'
    && /^\/administration\/store\/qr\/[^/]+$/.test(pathname);
  const adminHeaderImmediate = auth.role === 'admin' && (!isStoreRoute || isAdminQrRoute);

  const isHeaderVisible = (
    adminHeaderImmediate
    || (isUpdatedStoreDetails && isUpdatedTheme && HideThemeSkeleton && HideStoreDetailsSkeleton)
  );

  const showHeaderSkeleton = !isHeaderVisible && !isLoginPage && !adminHeaderImmediate;

  const openDrawerHandler = () => {
    setDrawerIsOpen(true);
  };

  const closeDrawerHandler = () => {
    setDrawerIsOpen(false);
  };

  useEffect(() => {
    const mainContainer = document.getElementById('main-container');
    if (!mainContainer) {
      return;
    }

    if (isLoginPage) {
      mainContainer.style.marginTop = '0rem';
      return;
    }

    if (isHeaderVisible || showHeaderSkeleton) {
      mainContainer.style.marginTop = '4rem';
    } else if (
      auth.role !== 'admin'
      && !isUpdatedStoreDetails
      && !isUpdatedTheme
      && !HideThemeSkeleton
      && !HideStoreDetailsSkeleton
    ) {
      mainContainer.style.marginTop = '0rem';
    }
  }, [
    auth.role,
    isLoginPage,
    isHeaderVisible,
    showHeaderSkeleton,
    isUpdatedStoreDetails,
    isUpdatedTheme,
    HideThemeSkeleton,
    HideStoreDetailsSkeleton,
    theme,
  ]);

  const storeName = getLocalizedValue(storeDetails?.name, currentLanguage);

  return (
    <React.Fragment>
      {showHeaderSkeleton && <Skeleton headerNavigationSkeleton />}

      {isHeaderVisible && (
      <React.Fragment>
        {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
        <SideDrawer show={drawerIsOpen}>
          <nav className="main-navigation__drawer-nav">
            <LanguageSwitcher variant="drawer" />
            <NavLinks showLogout onNavigate={closeDrawerHandler} />
          </nav>
        </SideDrawer>

        <MainHeader>
          <button className="main-navigation__menu-btn" onClick={openDrawerHandler}>
            <span />
            <span />
            <span />
          </button>

          <h1 className="main-navigation__title">
            <Link to="" onClick={(e) => e.preventDefault()}>{storeName || "storec"}</Link>
          </h1>


          <div className="main-navigation__header-actions">
            <LanguageSwitcher variant="header" />
            <nav className="main-navigation__header-nav">
              <NavLinks showLogout />
            </nav>
          </div>
        </MainHeader>
      </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default MainNavigation;
